import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import GuidingYourWayHome from "./sections/GuidingYourWayHome";
import MarketPulse from "./sections/MarketPulse";
import OurLendingExpertise from "./sections/OurLendingExpertise";
import TheBeaconPhilosophy from "./sections/TheBeaconPhilosophy";
import ClientSuccessStories from "./sections/ClientSuccessStories";
import StartYourJourney from "./sections/StartYourJourney";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <GuidingYourWayHome />
      <MarketPulse />
      <OurLendingExpertise />
      <TheBeaconPhilosophy />
      <ClientSuccessStories />
      <StartYourJourney />
      <Footer />
    </div>;
}